import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import ClientMarquee from '../components/ClientMarquee';
import AboutSection from '../components/AboutSection';
import DesignSection from '../components/DesignSection';
import ProductsSection from '../components/ProductsSection';
import CapabilitiesSection from '../components/CapabilitiesSection';
import CertificationsSection from '../components/CertificationsSection';
import SustainabilitySection from '../components/SustainabilitySection';
import ResourcesSection from '../components/ResourcesSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <ClientMarquee />
        <AboutSection />
        <DesignSection />
        <ProductsSection />
        <CapabilitiesSection />
        <CertificationsSection />
        <SustainabilitySection />
        <ResourcesSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
